export default __webpack_public_path__ + "static/media/0w20.6330d807.png";